import { colorConstants } from "../../constants";
import { colorService } from "../../services";
import { alertActions } from "../alert.actions";

export const coloryActions = {
  getSingleParameter,
  getAllParameters,
  addParameter,
  updateParameter,
  deleteParameter,
  clear,
};

// get single parameter
function getSingleParameter() {}

// get all parameter
function getAllParameters() {
  return (dispatch) => {
    dispatch(request());

    colorService.getAllParameters().then(
      (items) => dispatch(success(items)),
      (error) => dispatch(failure(error))
    );
  };

  function request(params) {
    return { type: colorConstants.GET_ALL_REQUEST, params };
  }
  function success(items) {
    return { type: colorConstants.GET_ALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: colorConstants.GET_ALL_FAILURE, error };
  }
}

// add parameter
function addParameter(english_name, chinese_name) {
  return (dispatch) => {
    dispatch(request(english_name, chinese_name));

    colorService.addParameter(english_name, chinese_name).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: colorConstants.ADD_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: colorConstants.ADD_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: colorConstants.ADD_FAILURE, error };
  }
}

// update parameter
function updateParameter(id, english_name, chinese_name) {
  return (dispatch) => {
    dispatch(request(id, english_name, chinese_name));

    colorService.updateParameter(id, english_name, chinese_name).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: colorConstants.UPDATE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: colorConstants.UPDATE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: colorConstants.UPDATE_FAILURE, error };
  }
}

// delete parameter
function deleteParameter(id) {
  return (dispatch) => {
    dispatch(request(id));

    colorService.deleteParameter(id).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: colorConstants.DELETE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: colorConstants.DELETE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: colorConstants.DELETE_FAILURE, error };
  }
}

// clear parameter
function clear() {
  return { type: colorConstants.CLEAR };
}
